var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
export const ColorCircle = forwardRef((_a, ref) => {
    var { color, size = 'md', onClick, invalid = false, className } = _a, rest = __rest(_a, ["color", "size", "onClick", "invalid", "className"]);
    return (React.createElement("button", Object.assign({ type: "button", ref: ref, className: clsx('rounded-full border border-line', invalid && 'ring ring-line-negative', onClick ? 'hover:border-line' : 'cursor-default', size === 'xs' && 'h-4 w-4', size === 'sm' && 'h-5 w-5', size === 'md' && 'h-8 w-8', size === 'lg' && 'h-10 w-10', className), style: {
            backgroundColor: color,
        }, onClick: onClick }, rest)));
});
//# sourceMappingURL=ColorCircle.js.map